import { cn } from "@/lib/utils";

// Label + control + inline error, used by the redesigned create dialogs.
export function Field({ label, required, optional, error, htmlFor, className, children }) {
  return (
    <div className={className}>
      <label htmlFor={htmlFor} className="block text-sm font-medium text-foreground mb-1.5">
        {label}
        {required && <span className="text-accent"> *</span>}
        {optional && <span className="font-normal text-muted-foreground"> (Optional)</span>}
      </label>
      {children}
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
}

export const inputShell =
  "flex items-center gap-2.5 rounded-lg border bg-card px-3.5 h-11 transition-colors focus-within:ring-2 focus-within:ring-primary/20 focus-within:border-primary/50";

export function IconInput({ icon: Icon, error, className, trailing, ...props }) {
  return (
    <div className={cn(inputShell, error ? "border-danger" : "border-border", className)}>
      <Icon className="h-4 w-4 text-muted-foreground shrink-0" strokeWidth={1.75} />
      <input
        {...props}
        aria-invalid={Boolean(error)}
        className="flex-1 min-w-0 bg-transparent text-sm placeholder:text-muted-foreground focus:outline-none"
      />
      {trailing}
    </div>
  );
}

// Select trigger styled to match IconInput; pass a Radix <SelectTrigger> className.
export const selectShell = (error) => cn("h-11 rounded-lg bg-card px-3.5", error ? "border-danger" : "border-border");
